export const API_ENDPOINT = (
  process.env.VUE_APP_API_ENDPOINT ||
  (process.env.NODE_ENV === "production"
    ? "https://incubator-cv.incubator-cv.com"
    : "http://localhost:8000")
).replace(/\/+$/, "");

export const FIFTEEN_MINUTES = 15 * 60 * 1000; // Sessão válida durante 15 minutos.

export function isSessionValid() {
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const loginTime = localStorage.getItem('loginTime');
  return storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES;
}
